/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Reset_Credentials_TitleInputs */



/**
* | output |
* | --- |
* | "Reset Credentials" |
*
* @param {Members_Reset_Credentials_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_reset_credentials_title = /** @type {((inputs?: Members_Reset_Credentials_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Reset_Credentials_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldedaten zurücksetzen")
	return /** @type {LocalizedString} */ ("Reset Credentials")
});